export default "__VITE_ASSET__9d597d23__"